<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
    <!-- อบรมนักธุรกิจอ่้อย -->
    <section>
        <!--
                <div class="card">
                    <div class="card-header bg-success">
                        <div class="card-title">บันทึกความรู้ความสามารถที่จำเป็นสำหรับชาวไร่</div>
                    </div>
                    <div class="card-body">
                        <div class="row ">
                            <div class="col"></div>
                            <div class="col-md-3">
                                <div *ngFor="let item of main_topic">
                                    <button type="button" [ngClass]="{'btn btn-outline-success btn-block' : true }"
                                        name="type" [value]="item.id"
                                        (click)="SubTypeSelectS(item.type,item.name)">เลือก:{{item.name}}
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <table class="table table-bordered" style="width:100%" *ngIf="selectSub_topic.length>0">
                                    <thead>
                                        <tr>
                                            <th style="width:15%"></th>
                                            <th style="width:65%">{{selectMain.m_name}}</th>
                                            <th style="width:20%;text-align:center;">ยกเลิก</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of selectSub_topic; let i = index;">
                                            <td style="text-align:center">{{i+1}}</td>
                                            <td>{{item.name}}</td>
                                            <td style="text-align:center;"><i class='fas fa-times'
                                                    style='font-size:20px;color:red'
                                                    (click)="cancel_topic(item.id)"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-3">
                                    <label cLabel for="s_name">เพิ่มหัวข้อย่อย:{{selectMain.m_name}}</label>
                                    <input type="text" class="form-control" aria-label="Default" id="s_name"
                                        formControlName="name" [(ngModel)]="selectMain.s_name">
                                </div>
                                <button type="button" class="btn btn-primary" (click)="saveMain_topic();"
                                    *ngIf="selectMain.s_name !=''">บันทึก</button>
                            </div>                            
                        </div>
                    </div>
                </div>
                -->

        <!-- บันทึกข้อมูลหลักสูตร -->
        <!--
                <div class="card" *ngIf="id_now==1">
                    <div class="card-header bg-primary">
                        <div class="card-title">บันทึกหลักสูตรการฝึกอบรมนักธุรกิจไร่อ้อย</div>
                        <p>Selected range: {{title_main.value | json}}</p>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col"></div>
                            <div class="col-md-7">

                                <div class="form-group">
                                    <mat-form-field class="example-full-width" appearance="fill">
                                        <mat-label>ชื่อหลักสูตรการอบรม</mat-label>
                                        <input matInput formControlName="title_docs" placeholder="" value="">
                                    </mat-form-field>
                                </div>
                                <div class="form-group">
                                    <mat-form-field class="example-full-width" appearance="fill">
                                        <mat-label>เนื้อหา/คำอธิบาย</mat-label>
                                        <textarea matInput formControlName="title_Des" placeholder=""></textarea>
                                    </mat-form-field>
                                </div>
                                <div class="form-group">
                                    <mat-form-field class="example-full-width" appearance="fill">
                                        <mat-label>ผู้บรรยาย</mat-label>
                                        <input matInput formControlName="lecturer" placeholder="">
                                    </mat-form-field>
                                </div>
                                <div class="form-group">
                                    <mat-form-field appearance="fill">
                                        <mat-label>ช่วงวันที่การฝึกอบรม</mat-label>
                                        <mat-date-range-input [rangePicker]="picker" disabled>
                                            <input matStartDate formControlName="dt_start" placeholder="วันที่เริ่มต้น">
                                            <input matEndDate formControlName="dt_end" placeholder="วันที่สุดท้าย">
                                        </mat-date-range-input>

                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                                    </mat-form-field>
                                </div>
                                <div class="form-group">
                                    <fieldset>
                                        <label class="form-label">รูปแบบการฝึกอบรม</label><br />
                                        <div>
                                            <input type="radio" formControlName="type_p" value="1"> อบรม
                                            <input type="radio" formControlName="type_p" value="2"> OJT
                                            <input type="radio" formControlName="type_p" value="3">ทั้ง 2 อย่าง
                                        </div>
                                    </fieldset>                                    
                                </div>

                                <div class="form-group">
                                    <label class="form-label">ความรู้</label><br />
                                    <div *ngFor="let data of sub_topic; let i=index">
                                        <label>
                                            <input type="checkbox" formControlName="data_info" name="data_info"
                                                [value]="data.id" (change)="onCheckboxChange($event)" />
                                            {{i+1}}-{{data.name}}
                                        </label>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-outline-primary"
                                    (click)="SavedataTrainGroup();">บันทึก</button>
                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                <button type="button" class="btn btn-outline-warning"
                                    (click)=" resetdataGroup();">รีเซ็ต</button>
                            </div>
                            <div class="col"></div>
                        </div>
                    </div>
                </div>
                -->

        <!-- บันทึกข้อมูลผลการอบรม -->
        <div class="card">
            <div class="card-header bg-warning">
                <div class="card-title">สมัครเข้าโครงการ</div>
                <!--
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" (click)="id_now=1;setaddfm = false;" data-toggle="tab" role="tab"
                            aria-selected="true">
                            <i class="fas fa-arrow-alt-circle-right"></i> บันทึกรายชาวไร่
                            <span class="badge bg-warning"></span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" (click)="id_now=2;setaddfm = false;" data-toggle="tab" role="tab"
                            aria-selected="false">
                            <i class="fas fa-arrow-alt-circle-right"></i> บันทึกรายแปลง
                            <span class="badge bg-warning"></span>
                        </a>
                    </li>
                </ul>
                -->
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <div class="p-2">เลือก</div>
                                    <div class="mr-auto p-2">
                                        <mat-form-field appearance="fill">
                                            <mat-label>โครงการ</mat-label>
                                            <!--(selectionChange)="($event.value)"-->
                                            <mat-select [(ngModel)]="data_se"
                                                (selectionChange)="Load_projectMem($event.value[0].dataid)">
                                                <mat-option selected disabled [value]="[]">--เลือกโครงการ--</mat-option>
                                                <mat-option *ngFor="let dt of Project_list"
                                                    [value]="[dt]">{{dt.projectName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="ml-auto p-2">
                                        <div class="btn-group" role="group" aria-label="Basic example"
                                            *ngIf="AlldataFm2.length>0">
                                            <button type="checkbox" class="btn btn-primary"
                                                [disabled]="data_se.length==0"
                                                (click)="set_type = 1;">เพิ่มชาวไร่</button>
                                            <button type="checkbox" class="btn btn-success"
                                                [disabled]="data_se.length==0"
                                                (click)="set_type = 2;">เพิ่มแปลง</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 text-left">
                                    <!--<label>{{ title_Desc[0] | json }}</label>-->
                                    <table class="table" *ngIf="data_se.length>0">
                                        <thead>
                                            <tr style="text-align:center">
                                                <th>ปี</th>
                                                <th>ชื่อหัวข้อ</th>
                                                <th>คำอธิบาย</th>
                                                <th>ช่วงวันที่โครงการ</th>
                                                <th>ผู้ดูแล</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of data_se" style="text-align:center">
                                                <td>{{item.yearid}}</td>
                                                <td>{{item.projectName}}</td>
                                                <td>{{item.projectDescript}}</td>
                                                <td>{{item.projectPeriodFrom | adtob}}-
                                                    {{item.projectPeriodEnd | adtob}}
                                                </td>
                                                <td>{{item.supname}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="card-body table-responsive p-2" style="height: 600px">
                                <table class="table table-sm table-striped table-hover table-head-fixed table-bordered"
                                    style="width:100%">
                                    <thead>
                                        <tr style="text-align:center">
                                            <th>No</th>
                                            <th>สมาชิก</th>
                                            <th>ชื่อสมาชิก</th>
                                            <th>วันที่เพิ่ม</th>
                                            <th>วันที่อัพเดต</th>
                                            <th>หมายเหตุ</th>
                                            <th>เลือก</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of member_list; let i = index;">
                                            <td style="text-align:center">{{i+1 | number}}</td>
                                            <td>{{item.member}}</td>
                                            <td>{{item.member_name}}</td>
                                            <td style="text-align:center">{{item.cre_date|adtob}}</td>
                                            <td style="text-align:center">{{item.up_date|adtob}}</td>
                                            <td>{{item.note}}</td>
                                            <td style="text-align:center;">
                                                <button type="button" class="btn btn-outline-danger"
                                                    (click)="push_arr(item.type,item.member,item.member,item.member_name,'0')">
                                                    <i class='fa fa-times' style='font-size:28;color:red'>
                                                    </i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card" *ngIf="set_type == 1">
                            <div class="card-header">เพิ่มชาวไร่ เข้าโครงการ
                                <mat-form-field class="example-form-field" appearance="outline">
                                    <mat-label>-*พิมพ์ข้อความ เพิ่อค้นหาชาวไร่*-</mat-label>
                                    <input matInput type="text" [(ngModel)]="txtFindIn" focus
                                        (ngModelChange)="search_dataFM()">
                                    <button *ngIf="txtFindIn" matSuffix mat-icon-button aria-label="Clear"
                                        (click)="txtFindIn=''"><mat-icon>close</mat-icon></button>
                                </mat-form-field>
                            </div>
                            <div class="card-body table-responsive p-2" style="height: 320px">
                                <table class="table table-sm table-striped table-hover table-head-fixed table-bordered"
                                    style="width:100%">
                                    <thead>
                                        <tr style="text-align:center;">
                                            <th>No</th>
                                            <th>โควตา</th>
                                            <th>ชื่อชาวไร่</th>
                                            <th>โซน</th>
                                            <th>เลือก</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of AlldataFm1 ; index as i">
                                            <td style="text-align:center;">{{i+1 | number}}</td>
                                            <td>{{item.fmcode}}</td>
                                            <td>{{item.fmname}}</td>
                                            <td style="text-align:center;">{{item.supzone}}</td>
                                            <td style="text-align:center;">
                                                <button type="button" class="btn btn-outline-success"
                                                    (click)="push_arr(1,item.fmcode,item.fmcode,item.fmname,1)">
                                                    <i class='fa fa-plus-square' style='font-size:28;color:green'>
                                                    </i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="card" *ngIf="set_type == 2">
                            <div class="card-header">เพิ่มแปลง เข้าโครงการ
                                <mat-form-field appearance="outline" *ngIf="AlldataFm2.length>0">
                                    <mat-label>เลือกชาวไร่</mat-label>
                                    <mat-select required (selectionChange)="Load_landno($event.value)">
                                        <mat-form-field class="example-form-field" appearance="outline">
                                            <mat-label>-*พิมพ์ข้อความ เพิ่อค้นหาชาวไร่*-</mat-label>
                                            <input matInput type="text" [(ngModel)]="txtFindIn" focus
                                                (ngModelChange)="search_dataFM()">
                                            <button *ngIf="txtFindIn" matSuffix mat-icon-button aria-label="Clear"
                                                (click)="txtFindIn=''"><mat-icon>close</mat-icon></button>
                                        </mat-form-field>
                                        <mat-option *ngFor="let item of AlldataFm1; let i = index;"
                                            [value]="item.fmcode">
                                            {{i+1}}.[{{ item.fmcode }}]-{{ item.fmname }}, โซน{{item.supzone}}
                                        </mat-option>
                                        <mat-option *ngIf="AlldataFm1.length==0" [value]=""
                                            disabled>.--ไม่พบข้อมูล--.</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="card-body table-responsive p-2" style="height: 320px">
                                <table class="table table-sm table-striped table-hover table-head-fixed table-bordered"
                                    style="width:100%">
                                    <thead>
                                        <tr style="text-align:center;">
                                            <th>No</th>
                                            <th>เลขแปลง</th>
                                            <th>โควตา</th>
                                            <th>ชื่อชาวไร่</th>
                                            <th>โซน</th>
                                            <th>พื้นที่</th>
                                            <th>ประเภทอ้อย</th>
                                            <th>เลือก</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of list_landno ; index as i">
                                            <td style="text-align:center;">{{i+1 | number}}</td>
                                            <td>{{item.intlandno}}</td>
                                            <td>{{item.fmcode}}</td>
                                            <td style="text-align:left;">{{item.fmname}}</td>
                                            <td>{{item.supzone}}</td>
                                            <td>{{item.landvalue_left|number}}</td>
                                            <td>{{item.canetype}}</td>
                                            <td style="text-align:center;">
                                                <button type="button" class="btn btn-outline-success"
                                                    (click)="push_arr(2,item.itid,item.intlandno,item.fmname,1)">
                                                    <i class='fa fa-plus-square' style='font-size:28;color:green'>
                                                    </i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="card" *ngIf="dataAr.length > 0">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-6">
                                        <mat-form-field class="example-form-field" appearance="outline">
                                            <mat-label>-ระบุหมายเหตุ(ถ้ามี)-</mat-label>
                                            <input matInput type="text" [(ngModel)]="note" focus
                                                (ngModelChange)="search_dataFM()">
                                            <button *ngIf="note" matSuffix mat-icon-button aria-label="Clear"
                                                (click)="note=''"><mat-icon>close</mat-icon></button>
                                        </mat-form-field>
                                    </div>
                                    <div class="col">
                                        <button mat-raised-button color="primary" (click)="insert_member();">บันทึก
                                            {{dataAr.length}} รายการ</button>
                                    </div>
                                    <div class="col">
                                        <button mat-raised-button color="warn" (click)="dataAr=[];">ล้างรายการ</button>
                                    </div>
                                </div>
                                รายการข้อมูลที่เลือก
                            </div>
                            <div class="card-body table-responsive p-2" style="height: 320px">
                                <table
                                    class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap"
                                    style="width:100%" *ngIf="dataAr.length>0">
                                    <thead>
                                        <tr style="text-align:center;">
                                            <th>No</th>
                                            <th>รหัส</th>
                                            <th>สมาชิก</th>
                                            <th>การเลือก</th>
                                            <th>ลบ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of dataAr ; index as i">
                                            <td style="text-align:center;">{{i+1 | number}}</td>
                                            <td>{{item.code}}</td>
                                            <td>{{item.name}}</td>
                                            <td style="text-align:center;">
                                                <a class="list-group-item-action list-group-item-success"
                                                    *ngIf="item.status=='1'">เข้าโครงการ</a>
                                                <a class="list-group-item-action list-group-item-danger"
                                                    *ngIf="item.status=='0'">ลบรายการ</a>
                                            </td>
                                            <td style="text-align:center;">
                                                <i class='fas fa-times' style='font-size:22px;color:red'
                                                    (click)="delete_value(item.member);"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<app-footer></app-footer>